import axios from 'axios'
const baseURL = process.env.VUE_APP_BASE_URL_API
const baseURL2 = process.env.VUE_APP_BASE_URL_API2

const service = axios.create({
  baseURL: baseURL,
  timeout: 80000,
})
const service2 = axios.create({
  baseURL: baseURL2,
  timeout: 80000,
})

// 请求拦截器
service.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么，比如添加请求头等操作
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    return response.data
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)

// 请求拦截器
service2.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么，比如添加请求头等操作
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
service2.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    return response.data
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)

export { baseURL, service, service2 }
